import React, { useState } from "react";
import { Field } from "redux-form";
import { months } from "../../../../../../Utils/months";
import {
    renderDollar,
    renderDollarDisabledWhithNegative,
} from "../../../../../../Utils/renderField/renderField";
import { calcularTodosLosTotales } from "../../utils/calculosTotales";
import "../../Resultados.css";

const TITULOS_CATEGORIA = {
    VENTAS: "(+) VENTAS",
    COSTO_VENTA: "(-) COSTO DE VENTA",
    RESULTADO_BRUTO: "(=) RESULTADO BRUTO",
    GASTOS_OPERACION: "(-) GASTOS DE OPERACIÓN",
    RESULTADO_OPERACION: "(=) RESULTADO EN OPERACIÓN",
    GASTOS_FINANCIEROS: "(-) GASTOS FINANCIEROS",
    DEPRECIACIONES: "(-) DEPRECIACIONES",
    OTROS_INGRESOS_GASTOS: "(+) OTROS INGRESOS / (-) OTROS GASTOS",
    RESULTADO_COMERCIALIZACION: "(=) RESULTADO EN LA COMERCIALIZACIÓN",
    ISR: "(-) ISR",
    RESULTADO_DESPUES_IMPUESTOS: "(=) RESULTADO DESPUÉS DE IMPUESTOS",
    RESULTADO_OPERACION_AGRICOLA: "(+) RESULTADO EN OPERACIÓN AGRÍCOLA",
    RESULTADO_COMBINADO: "(=) RESULTADO COMBINADO",
};

const CATEGORIAS_CON_PORCENTAJE = [
    "COSTO_VENTA",
    "RESULTADO_BRUTO",
    "GASTOS_OPERACION",
    "RESULTADO_OPERACION",
    "GASTOS_FINANCIEROS",
    "RESULTADO_COMERCIALIZACION",
];

const CATEGORIA_ORDER = [
    "VENTAS",
    "COSTO_VENTA",
    "RESULTADO_BRUTO",
    "GASTOS_OPERACION",
    "RESULTADO_OPERACION",
    "GASTOS_FINANCIEROS",
    "DEPRECIACIONES",
    "OTROS_INGRESOS_GASTOS",
    "RESULTADO_COMERCIALIZACION",
    "ISR",
    "RESULTADO_DESPUES_IMPUESTOS",
    "RESULTADO_OPERACION_AGRICOLA",
    "RESULTADO_COMBINADO",
];

function formatCurrency(value) {
    var num = Number(value);
    var formatted =
        "$\u00A0" +
        num.toLocaleString("es-GT", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    return num < 0 ? (
        <span style={{ color: "red" }}>{formatted}</span>
    ) : (
        formatted
    );
}

const ResultadosTable = ({ resultados_data, currency, change, data }) => {
    const [openCategorias, setOpenCategorias] = useState(() => {
        const initial = {};
        CATEGORIA_ORDER.forEach((cat) => {
            initial[cat] = false;
        });
        return initial;
    });

    // Estado para controlar la visibilidad de ISR y RESULTADO_DESPUES_IMPUESTOS
    const [mostrarISR, setMostrarISR] = useState(false);

    // Categorías que deben tener fondo amarillo
    const CATEGORIAS_AMARILLAS = [
        "RESULTADO_BRUTO",
        "RESULTADO_OPERACION", 
        "RESULTADO_COMERCIALIZACION",
        "RESULTADO_DESPUES_IMPUESTOS",
        "RESULTADO_COMBINADO"
    ];

    if (!resultados_data || typeof resultados_data !== "object") return null;
    if (!data || !data.year_list) return null;

    var totals = calcularTodosLosTotales(resultados_data, data.year_list);
    var totalesMap = totals.totalesMap;
    var ventasTotales = totalesMap["VENTAS"] || {};

    const toggleCategoria = (categoria) => {
        setOpenCategorias((prev) => ({
            ...prev,
            [categoria]: !prev[categoria],
        }));
    };

    return (
        <div className="resultados-table-container">
            {/* Botón pequeño y discreto para mostrar/ocultar ISR */}
            <div className="mb-2 boton-isr-fijo">
                <small>
                    <button 
                        type="button"                                                                                                 
                        className="btn btn-xs btn-link p-0"
                        style={{ fontSize: '12px', textDecoration: 'none' }}
                        onClick={() => setMostrarISR(!mostrarISR)}
                    >
                        {mostrarISR ? '− Ocultar' : '+ Mostrar'} ISR
                    </button>
                </small>
            </div>
            
            <table className="table mb-0 text-center min-w-500 resultados-table">
                <thead>
                    <tr>
                        <th
                            rowSpan={2}
                            className="text-left resultados-cell-left resultados-border-top resultados-header td--shadow-right"
                        >
                            Categoría
                        </th>
                        {data.year_list.map(function (year, i) {
                            const isLast = i === data.year_list.length - 1;
                            return (
                                <th
                                    key={i}
                                    colSpan={1}
                                    className={`resultados-header ${
                                        !isLast ? "tr--border-right" : ""
                                    }`}
                                >
                                    {year}
                                </th>
                            );
                        })}
                    </tr>
                    <tr className="tr--no-radius tr--border-top">
                        {data.year_list.map(function (_, i) {
                            const isLast = i === data.year_list.length - 1;
                            return (
                                <th
                                    key={i}
                                    className={`resultados-subheader resultados-border-right ${
                                        !isLast ? "tr--border-right" : ""
                                    }`}
                                >
                                    Presupuesto
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {CATEGORIA_ORDER.map(function (categoriaKey, i) {
                        var filas = resultados_data[categoriaKey];
                        var totales = totalesMap[categoriaKey];
                        const mostrarPorcentaje =
                            totales &&
                            CATEGORIAS_CON_PORCENTAJE.includes(categoriaKey);
                        const isOpen = openCategorias[categoriaKey];

                        const renderTotalesRow = () => {
                            const anual = {
                                presupuestado: 0,
                            };
                            for (var i = 0; i < months.length; i++) {
                                const key = months[i].toLowerCase();
                                const t = totales[key] || {};
                                const p = t.presupuestado || 0;

                                anual.presupuestado += p;
                            }
                            return (
                                <tr
                                    className={`resultados-categoria-header ${
                                        CATEGORIAS_AMARILLAS.includes(categoriaKey) 
                                            ? 'resultado-amarillo' 
                                            : ''
                                    } ${
                                        (categoriaKey === 'ISR' || categoriaKey === 'RESULTADO_DESPUES_IMPUESTOS') && !mostrarISR
                                            ? 'fila-oculta'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        toggleCategoria(categoriaKey)
                                    }
                                    style={{ cursor: "pointer" }}
                                >
                                    <td className="resultados-categoria-titulo text-uppercase font-weight-bold text-left td--shadow-right">
                                        {TITULOS_CATEGORIA[categoriaKey] ||
                                            categoriaKey}
                                    </td>

                                    {data.year_list.map(function (year, mi) {
                                        var key = year.toLowerCase();
                                        var yearClass =
                                            mi % 2 === 0
                                                ? ""
                                                : "resultados-mes-par";
                                        var v = ventasTotales[key] || {};
                                        var p = v.presupuestado || 0;
                                        var pp =
                                            (totales[key] &&
                                                totales[key].presupuestado) ||
                                            0;
                                        var perPres =
                                            p > 0 ? (pp / p) * 100 : 0;

                                        return (
                                            <td
                                                key={year}
                                                className={`${yearClass} font-weight-bold text-right align-top resultados-border-right tr--border-right`}
                                                style={{ fontSize: "14px" }}
                                            >
                                                <div>
                                                    {formatCurrency(pp)}
                                                </div>
                                                {mostrarPorcentaje && (
                                                    <div className="text-danger">
                                                        {perPres.toFixed(1)}
                                                        %
                                                    </div>
                                                )}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        };

                        if (!filas || !Array.isArray(filas)) {
                            if (!totales) return null;
                            return (
                                <React.Fragment key={categoriaKey}>
                                    {renderTotalesRow()}
                                </React.Fragment>
                            );
                        }

                        return (
                            <React.Fragment key={i}>
                                {renderTotalesRow()}
                                {isOpen &&
                                    filas.map(function (fila, filaIdx) {
                                        return (
                                            <tr 
                                                key={filaIdx}
                                                className={`${
                                                    (categoriaKey === 'ISR' || categoriaKey === 'RESULTADO_DESPUES_IMPUESTOS') && !mostrarISR
                                                        ? 'fila-oculta'
                                                        : ''
                                                }`}
                                            >
                                                <td className="td--shadow-right resultados-cell-left text-left">
                                                    {fila.nombre}
                                                </td>
                                                {data.year_list.map(function (
                                                    year,
                                                    mi
                                                ) {
                                                    var key =
                                                        year.toLowerCase();

                                                    return (
                                                        <td
                                                            key={year}
                                                            className="resultados-border-right tr--border-right"
                                                        >
                                                            <Field
                                                                name={
                                                                    categoriaKey +
                                                                    "." +
                                                                    filaIdx +
                                                                    "." +
                                                                    key +
                                                                    ".presupuestado"
                                                                }
                                                                type="text"
                                                                component={renderDollarDisabledWhithNegative}
                                                                className="form-control"
                                                                placeholder="$0.00"
                                                                highlightNegative
                                                            />
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default ResultadosTable;
